<template>
  <FormLabel :text="text" :error="error">
    <HiddenField :name="name" :value="value" />
    <button :disabled="$store.state.loading" class="aoformfield aoformfield_pointer aoformfield_witharrow" aria-haspopup="listbox" aria-label="text">{{value}} 
      <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L5 5L9 1" stroke="#282423" stroke-width="2"/>
      </svg>
    </button>
    <DropList :options="options" v-model="val" />
  </FormLabel> 
</template>

<script>
import FormLabel from '@/components/FormLabel.vue'
import HiddenField from '@/components/HiddenField.vue'
import FormField from '@/mixins/FormField.vue'
import DropList from '@/components/DropList.vue'

export default {
  components: { FormLabel, HiddenField, DropList },
  mixins: [FormField],
  props: {
    name: {type: String, required: true},
    value: {type: String, default: ''},
    text: {type: String, required: true},
    options: {type: Array, required: true},
    validation: {type: Function, default: ()=>''}
  },
  data: ()=>({
    error: ''
  }),
  mounted(){
    this.val = this.options[0]
  },
  computed:{
    val: {
      get () { return this.value },
      set (value) { this.$emit('input', value) },
    },
  },
  watch: {
    value(newVal){
      this.error = this.validation(newVal)
    }
  }
}
</script>

<style lang="sass">

</style>